<template>
  <table class="table tabled-list">
    <tbody>
      <slot>
        <tr v-for="(item, index) in items" :key="index">
          <td>
            {{ item.key }}
            <LearnMore class="help-icon" v-if="item.help" :help="item.help" />
          </td>
          <td>{{ item.value }}</td>
        </tr>
      </slot>
    </tbody>
  </table>
</template>

<script>
import LearnMore from "@/components/display/LearnMore";

export default {
  name: "CardTabledList",
  components: { LearnMore },
  props: {
    items: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.tabled-list {
  margin-bottom: 0;
  tbody {
    tr:first-of-type {
      td {
        border-top: none;
      }
    }
    tr {
      td {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
        vertical-align: middle;
        &:last-of-type {
          font-weight: bold;
          text-align: end;
          padding-right: 0.75rem;
        }
        label {
          font-size: inherit;
          vertical-align: inherit;
          color: inherit;
          margin: 0;
        }
      }
    }
  }
  .help-icon {
    display: inline-flex;
    vertical-align: sub;
  }
}
</style>
